import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { AppInfoService, AuthService } from '../../services';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent {
  login = '';
  password = '';
  message = '';

  constructor(
    private authService: AuthService,
    public appInfo: AppInfoService
  ) {}

  prijava(l, p) {
    let objektZaSlanje = {
      korisnickoime: l,
      password: p,
      ip_nazivsoftvera: 'pekar_proizvodnja'
    };
    //console.log(objektZaSlanje);

    this.authService.login(objektZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        localStorage.setItem('iduser', res.user[0]['login']);
        localStorage.setItem('user', res.user[0]['name']);
        localStorage.setItem('idsecuser', res.user[0]['idsec_users']);
        localStorage.setItem('token', res.user[0]['token']);
        localStorage.setItem('firma', res.user[0]['firma_id_firma']);
        sessionStorage.setItem('token', res.user[0]['token']);

        //DOHVATITI API PRAVA KORISNIKA (IF PETLJA)
        this.authService
          .pravaKorisnika({ idkorisnik: res.user[0]['idsec_users'] })
          .subscribe((res) => {
            //console.log(res);
            if (res.success === true) {
              sessionStorage.setItem(
                'pravakorisnika',
                JSON.stringify(res.data)
              );

              this.authService.logIn(l, p);
            } else {
              sessionStorage.clear();
            }
          });
      } else {
        //console.log(res.message);
        this.message = res.message;
      }
    });
  }

  onLoginClick(args, l, p) {
    (this.login = l), (this.password = p);
    if (!args.validationGroup.validate().isValid) {
      return;
    }
    this.prijava(l, p);
    args.validationGroup.reset();
  }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxValidationGroupModule,
  ],
  declarations: [LoginFormComponent],
  exports: [LoginFormComponent],
})
export class LoginFormModule {}
